import script from "./CustomPlanCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPlanCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__